import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { PhotoAppointmentSelectComponent } from './photo-appointment-select.component';
import { SharedModule } from '../../shared.module';
@NgModule({
    declarations: [
        PhotoAppointmentSelectComponent
    ],
    imports: [
        IonicModule,
        CommonModule,
        SharedModule
    ],
    exports: [
        PhotoAppointmentSelectComponent,
    ],
    providers: []
})
export class PhotoAppointmentSelectComponentModule {}
